export const dashboardRoutes = (apiBase) => ({
  dashboardIndicadores: `${apiBase}/dashboard/indicadores`,
  dashboardEps: `${apiBase}/dashboard/eps`,
  dashboardConfig: `${apiBase}/dashboard/configuracion`,
  dashboardCatalogoFiltro: `${apiBase}/dashboard/catalogo-filtro`,
});
